'use strict';

module.exports = {
  load: function() {},
};



// WEBPACK FOOTER //
// ./src/config/coachfrog/3rdPartyLibs.js